import clsx from 'clsx'
import { useState } from 'react'
import { Key, WarningCircle } from 'phosphor-react'

import { Button } from '../../../../components/Button'
import { DialogModal } from '../../../../components/DialogModal'
import { ReactComponent as EditSvg } from '../../../../assets/svgs/edit.svg'
import { ReactComponent as TrashSvg } from '../../../../assets/svgs/secondary-trash.svg'
import { ReactComponent as ArrowRightSvg } from '../../../../assets/svgs/arrow-right.svg'
import { useMediaQuery } from '../../../../hooks/useMediaQuery'
import { Medias } from '../../../../enumns/medias'
import { Can } from '../../../../guards/GuardContext'

type TableRowActionsProps = {
  tableContentType: string
  isRemovingRegister: boolean
  cannotRemove?: boolean
  alertMessage: string
  onEdit?: () => unknown
  onView?: () => void
  onRemove?: (successAction: () => void) => void
  onResetPassword?: () => void
}

export const TableRowActions = ({
  tableContentType,
  isRemovingRegister,
  cannotRemove = false,
  alertMessage,
  onEdit,
  onRemove,
  onView,
  onResetPassword,
}: TableRowActionsProps) => {
  const [isModalAlertOpen, setIsModalAlertOpen] = useState(false)

  const isMinimumWidthOfATablet = useMediaQuery(`(min-width: ${Medias.MD}px)`)

  const handleConfirmRemoval = () => {
    if (onRemove) {
      onRemove(() => setIsModalAlertOpen(false))
    }
  }

  return (
    <>
      <div className="flex items-center gap-4">
        {!!onEdit && (
          <Can I="update" a={tableContentType}>
            <button onClick={onEdit} title="Editar">
              <EditSvg className="stroke-grey-700" />
            </button>
          </Can>
        )}
        {!!onResetPassword && (
          <Can I="update" a={tableContentType}>
            <button onClick={onResetPassword} title="Redefinir senha">
              <Key size={20} className="text-grey-700" />
            </button>
          </Can>
        )}
        {!!onRemove && (
          <Can I="delete" a={tableContentType}>
            <button
              className={clsx({
                'disabled:opacity-50': cannotRemove,
              })}
              onClick={() => setIsModalAlertOpen(true)}
              disabled={cannotRemove}
            >
              <TrashSvg />
            </button>
          </Can>
        )}
        {!!onView && (
          <button onClick={onView}>
            <ArrowRightSvg />
          </button>
        )}
      </div>

      <DialogModal
        isOpen={isModalAlertOpen}
        onClose={
          isMinimumWidthOfATablet ? () => setIsModalAlertOpen(false) : undefined
        }
      >
        <div className="px-8 pb-6">
          <WarningCircle
            size={72}
            className="mx-auto mb-10 text-primary-light"
          />
          <p className="text-center mb-14 text-grey-900">{alertMessage}</p>

          <div className="flex items-center gap-2">
            <Button
              type="button"
              variant="outline"
              onClick={() => setIsModalAlertOpen(false)}
              fullWidth
            >
              Cancelar
            </Button>
            <Button
              type="button"
              variant="primary"
              onClick={handleConfirmRemoval}
              isLoading={isRemovingRegister}
              fullWidth
            >
              Continuar
            </Button>
          </div>
        </div>
      </DialogModal>
    </>
  )
}
